import React from 'react';
import PropertyGridUtils from '../PropertyGridUtils';
import ColorSelector from './ColorSelector';
import PropertyEditor from "../PropertyEditor";

export default class ColorEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <ColorSelector value={this.props.source.value} onChange={e => this.onChange(e)} />
        );
    }
}

PropertyGridUtils.register("color", (source, propertyGrid) => <ColorEditor source={source} propertyGrid={propertyGrid} />);